import { Routes, RouterModule } from '@angular/router';

import { HisSearchPrintviewComponent } from './component/his-search-printview.component';

// canActivate: [HisAuthGuard],
const GENERIC_SEARCH_ROUTES: Routes = [
    {
        path: 'print-view',
        component: HisSearchPrintviewComponent,
        data: {
            hasAll: ['RIGHT_EVERYONE']
        }
    },

];

// eslint-disable-next-line @typescript-eslint/naming-convention
export const HisGenericsearchRoutesModule = RouterModule.forChild(GENERIC_SEARCH_ROUTES);
